/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
import React from "react";
import PropTypes from "prop-types";
import vaultUtil from "../../utils/vault-util";
import SecretReference from "../common/SecretReference";
function SecretDisplayValue(_ref) {
  var mask = _ref.mask,
    value = _ref.value,
    warning = _ref.warning;
  var isReference = !!vaultUtil.parseValue(value);
  if (!isReference) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ocr--root-container"
    }, mask);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "ocr--root-container"
  }, /*#__PURE__*/React.createElement(SecretReference, {
    reference: value,
    warning: warning
  }));
}
SecretDisplayValue.propTypes = {
  mask: PropTypes.string,
  value: PropTypes.string.isRequired
};
SecretDisplayValue.defaultProps = {
  mask: "**********"
};
export default SecretDisplayValue;